import useBackend from '@/backend';
import { cache, useState } from 'react';

/* --------------------------------- OPTIONS -------------------------------- */
const route = (token: string | null) =>
	token ? '/bonus/offers?pageSize=50' : '/bonus?pageSize=50';

const headers: HeadersInit = {
	'Content-Type': 'application/json',
};

/* -------------------------------------------------------------------------- */

export const useGetBonuses = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const { url_V3, getAccessToken } = useBackend();

	const getBonuses = cache(async () => {
		try {
			const token = await getAccessToken({ v: 3 });

			if (token) headers.Authorization = token;

			const apiUrl = `${url_V3}${route(token)}`;

			const response = await fetch(apiUrl, {
				headers,
			});

			if (!response.ok) {
				throw new Error('Failed to load user data');
			}

			const apiData = await response.json();

			if (apiData.success) {
				const data = apiData?.data;

				return data;
			}
			return null;
			/* -------------------------------------------------------------------------- */
		} catch (e: unknown) {
			const message = e instanceof Error ? e.message : 'Unknown error';
			setError(message);

			return { bonuses: null, error: 'Failed to load user data' };
		} finally {
			setLoading(false);
		}
	});
	return {
		getBonuses,
		loading,
		error,
	};
};
